import { Navigate } from 'react-router-dom';

// Sign-in is handled by Clerk in `LoggedInGuard`, outside ra-core. ra-core still
// redirects to `/login` (e.g. after logout), so send the user back to the app root.
export const LoginRedirect = () => <Navigate to="/" replace />;
